import { isNoteOperation } from './approvalNoteOperation';
export const getShowsNestedPanel = ({
  isNestedPanelGateOn,
  showModal,
  currentOperation,
  currentStepId,
  hasSidebar
}) => isNestedPanelGateOn && showModal && isNoteOperation(currentOperation) && currentStepId !== null && hasSidebar;